// Operações em base decimal para acompanhar o arredondamento comercial da API.
function powerOfTen(exponent: number): bigint {
  let result = BigInt(1);
  for (let i = 0; i < exponent; i++) result *= BigInt(10);
  return result;
}

function decimalParts(value: number): { integer: bigint; scale: number } {
  if (!Number.isFinite(value)) throw new Error('Valor financeiro inválido.');
  const [coefficient, exponent = '0'] = value.toString().toLowerCase().split('e');
  const [whole, fraction = ''] = coefficient.split('.');
  const scale = fraction.length - Number(exponent);
  const integer = BigInt(whole + fraction);
  return scale < 0
    ? { integer: integer * powerOfTen(-scale), scale: 0 }
    : { integer, scale };
}

function toMoney(integer: bigint, scale: number): number {
  if (scale <= 2) return Number(integer * powerOfTen(2 - scale)) / 100;
  const divisor = powerOfTen(scale - 2);
  const sign = integer < BigInt(0) ? BigInt(-1) : BigInt(1);
  const absolute = integer * sign;
  const cents = absolute / divisor + (absolute % divisor * BigInt(2) >= divisor ? BigInt(1) : BigInt(0));
  return Number(cents * sign) / 100;
}

export function roundComprasMoney(value: number): number {
  const { integer, scale } = decimalParts(value);
  return toMoney(integer, scale);
}

export function comprasItemTotal(quantity: number, unitPrice: number): number {
  const quantityParts = decimalParts(quantity);
  const unitParts = decimalParts(roundComprasMoney(unitPrice));
  return toMoney(quantityParts.integer * unitParts.integer, quantityParts.scale + unitParts.scale);
}
